<script>
    import Dropzone from 'svelte-file-dropzone';

    let files = {
        accepted: [],
        rejected: [],
    };

    let uploading = false;
    export let filesSelected;

    async function handleFiles(e) {
        uploading = true;

        const { acceptedFiles, fileRejections } = e.detail;
        files.accepted = [...files.accepted, ...acceptedFiles];
        files.rejected = [...files.rejected, ...fileRejections];

        if (filesSelected) {
            await filesSelected(files);
            files.accepted = [];
            uploading = false;
        }
    }
</script>

<div class="wrapper">
    {#if uploading}
        <div class="spinner-wrapper">
            <div class="spinner-border spinner-border-sm text-secondary" role="status">
                <span class="sr-only" />
            </div>
        </div>
    {:else}
        <Dropzone on:drop={handleFiles} containerClasses="dropzone" accept="image/*">
            <div class="dropzone-inner" title="Klicka för att bläddra eller släpp bilder direkt här för att ladda upp dem">
                <i class="fas fa-plus-circle" /><br />
                Släpp bilder här<br />för att ladda upp
            </div>
        </Dropzone>
    {/if}
</div>

<style>
    .wrapper {
        display: inline-block !important;
        width: 100px;
        height: 100px;
        margin-right: 2px;
    }

    .spinner-wrapper {
        padding: 42px 0 0 42px;
    }

    .spinner-border {
        font-size: larger;
    }

    :global(.dropzone) {
        text-align: center;
        border: 1px dashed silver;
        color: silver;
        margin: 0;
        width: 100%;
        height: 100%;
        padding: 20px 0 0 0 !important;
        transition: none !important;
        cursor: pointer;
    }

    :global(.dropzone:hover) {
        color: rgb(0, 120, 168) !important;
        border-color: rgb(0, 120, 168) !important;
    }

    .fa-plus-circle {
        font-size: 20px;
        line-height: 30px;
    }
</style>
